<template>
  <Stack
    id="header"
    :class="{ 'stk-py-8': variant === 'person'}"
  >
    <Stack v-if="hasFetchedTree">
      <div v-if="variant === 'person'">
        <Title size="6">
          Householding
        </Title>
        <Subtitle size="4">
          Manage households of people and accounts
        </Subtitle>
      </div>

      <GroupManagement
        :tree-data="treeData"
        :current-entity-id="entityExternalId"
        @onSuccess="fetchEntityTree"
      />
    </Stack>

    <LoaderWithText v-else>
      Fetching relationships…
    </LoaderWithText>
  </Stack>
</template>

<script>
import { LoaderWithText, Stack, Subtitle, Title } from '@stakeui';
import GroupManagement from '@frontend/ui/features/people/GroupManagement.vue';

export default {
  name: 'PermissionsGroups',
  components: {
    GroupManagement,
    LoaderWithText,
    Stack,
    Subtitle,
    Title,
  },
  props: {
    entityExternalId: {
      type: String,
      required: true,
    },
    entity: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: 'person',
    },
  },
  data() {
    return {
      treeData: null,
      currentParent: null, // Store the result here instead of computing it directly
      hasFetchedTree: false,
    };
  },

  watch: {
    treeData(newTreeData) {
      if (newTreeData) {
        this.updateCurrentParent();
      }
    },
    entity: {
      deep: true,
      handler(newEntity) {
        if (newEntity) {
          this.updateCurrentParent();
        }
      },
    },
  },

  created() {
    this.fetchEntityTree();
  },
  methods: {
    async fetchEntityTree() {
      try {
        const response = await fetch(`/api/v1/entities/${this.entityExternalId}/tree/`);
        if (!response.ok) throw new Error('Failed to fetch entity tree');
        this.treeData = await response.json();
      } catch (error) {
        console.error(error);
      } finally {
        this.hasFetchedTree = true;
      }
    },

    updateCurrentParent() {
      if (!this.entity?.parent_entities?.length || !Array.isArray(this.treeData)) {
        this.currentParent = null;
        return;
      }

      const findEntityById = (nodes, id) => {
        for (const node of nodes) {
          if (node?.entity?.id === id) return node.entity;
          if (Array.isArray(node.descendants)) {
            const found = findEntityById(node.descendants, id);
            if (found) return found;
          }
        }
        return null;
      };

      const parentEntity = findEntityById(this.treeData, this.entity.parent_entities[0]);
      if (parentEntity) {
        this.currentParent = parentEntity;
      }
    },
  },
};
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--stk-size-8);
}

.tree {
  grid-column: 1;
}

.groups {
  grid-column: 2;
}
</style>
